import conv1dGif from "../../../../content/posts/2021-04-08-graph-convolutional-networks/conv1d.gif";
import * as React from 'react';
export default {
  conv1dGif,
  React
};